import Background from "./Background";
import "./BookTokens.css";
import Book from "../assets/book.webp";
import { useNavigate } from "react-router-dom";

function BookTokens() {
  const navigate = useNavigate();

  return (
    <>
      {" "}
      <Background />
      <div className="book-tokens-packages">
        <div
          className="package"
          onClick={() => navigate("/payment?id=price_1R0jUiEiJZm6GgyMJqWzKWGE")}
        >
          <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            + 4 <img src={Book} style={{ height: "34px" }}></img>
          </span>
          <span style={{ borderTop: "2px white solid" }}>1,99€</span>
        </div>
        <div
          className="package"
          onClick={() => navigate("/payment?id=price_1R0jWmEiJZm6GgyMo6gR0VVm")}
        >
          <span style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            + 10 <img src={Book} style={{ height: "34px" }}></img>
          </span>
          <span style={{ borderTop: "2px white solid" }}>3,99€</span>
        </div>
      </div>
    </>
  );
}

export default BookTokens;
